import {getCustomerOfferQueryOptions} from "@project/application/sales/customer-offers";
import {AppErrorBoundary} from "@project/layouts";
import {createFileRoute} from "@tanstack/react-router";

import {routeMessages} from "../../../../../messages/routes.messages";

import {OfferPage} from "./-page/offer.page";
import {OfferPending} from "./-page/offer.pending";

export const Route = createFileRoute("/_app/sales/offers/$offerId")({
  component: RouteComponent,
  errorComponent: AppErrorBoundary,
  loader: async ({context: {queryClient}, params}) =>
    queryClient.ensureQueryData(getCustomerOfferQueryOptions(params.offerId)),
  pendingComponent: OfferPending,
  staticData: {
    meta: {
      getLabel: (params: Record<string, string>, data?: unknown) =>
        data &&
        typeof data === "object" &&
        "customerOfferId" in data &&
        typeof data.customerOfferId === "string" &&
        data.customerOfferId.toLowerCase() === params.offerId?.toLowerCase() &&
        "name" in data &&
        typeof data.name === "string"
          ? data.name
          : undefined,
      getLabelDescriptor: (p: Record<string, string>) => ({
        id: routeMessages.offerById.id,
        values: {offerId: p["offerId"]},
      }),
    },
  },
});

function RouteComponent() {
  const {offerId} = Route.useParams();
  return <OfferPage offerId={offerId} />;
}
